import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import DownloadFile from '@/assets/common/downloadFile';

interface VideoProps {
  title: string;
  text: string;
  videoUrl?: string;
  pdfUrl?: string;
}

const Tutorial = ({ title, text, videoUrl, pdfUrl }: VideoProps) => {
  const theme = useTheme();
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Box
      // elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'start',
        justifyContent: 'start',
        // padding: `${theme.spacing(2)} 0`,
        borderRadius: '9px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      {pdfUrl ? (
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            textDecoration: 'none',
            color: 'inherit',
            aspectRatio: '16 / 9',
            width: '100%',
          }}
        >
          <Box
            sx={{
              borderRadius: '9px 9px 0 0',
              aspectRatio: '16 / 9',
              width: '100%',
              backgroundColor: '#f9f9f9',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DownloadFile sx={{ width: '90px', height: 'auto' }} />
          </Box>
        </a>
      ) : (
        <Box
          sx={{
            borderRadius: '9px 9px 0 0',
            aspectRatio: '16 / 9',
            width: '100%',
            backgroundColor: '#f9f9f9',
            position: 'relative',
          }}
        >
          {!isLoaded && (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ borderRadius: '9px', position: 'absolute' }}
            />
          )}

          <video
            style={{
              width: '100%',
              borderRadius: '9px',
              display: isLoaded ? 'block' : 'none',
            }}
            src={videoUrl}
            controls
            onLoadedData={() => setIsLoaded(true)}
          />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '10px',
          [theme.breakpoints.down('sm')]: {
            padding: '5px',
          },
        }}
      >
        <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
          {title}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: theme.palette.secondary.main, marginTop: '10px' }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default Tutorial;
